import chain from 'app/_shared/events/util/chain'
import searchWith from 'app/_shared/events/search/with'
import infinite from 'app/_shared/events/search/infinite'
import { curry } from 'lib/util'

export default {
  onOpen: {
    infiniteWithQuery: chain(
      searchWith(['query']),
      infinite(null),
    ),
  },
  query: {
    deviceServiceHasContactData: curry((module, component, event) => {
      return 'metatype:organisation AND publishServiceContactData:(true)'
    }),
  }
}
